import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
var firebase = require("firebase/app")

Vue.use(VueRouter)

const beforeEnter = (to, from, next) => {
  if (store.state.authModule.logged) {
		next({ path: "/clientes" });
  } else {
    next();
  }
};

const routes = [
  {
    path: "/registro",
    name: "Registro",
    component: () => import("../views/Register.vue"),
		meta: { requiresAuth: false, role: "guest", title: "MENU-QR Registro" },
		beforeEnter: (to, from, next) => beforeEnter(to, from, next),
  },
  {
    path: "/registro-express",
    name: "RegistroExpress",
    component: () => import("../views/RegisterExpress.vue"),
		meta: { requiresAuth: false, role: "guest", title: "MENU-QR Registro" },
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
		meta: { requiresAuth: false, role: "guest", title: "MENU-QR Ingreso" },
		beforeEnter: (to, from, next) => beforeEnter(to, from, next),
	},
	
	{
		path: "/clientes",
		name: "CustomerDashboard",
		component: () => import("../views/customer/Index.vue"),
		meta: { requiresAuth: true,role: "customer",title: "Escritorio Administrativo",},
	},
	{
		path: "/clientes/negocio",
		name: "CustomerBusiness",
		component: () => import("../views/customer/Business.vue"),
		props: true,
		meta: { requiresAuth: true,role: "customer",title: "Negocio",},
	},
	{
		path: "/clientes/usuario",
		name: "CustomerUser",
		component: () => import("../views/customer/User.vue"),
		props: true,
		meta: { requiresAuth: true,role: "customer",title: "Usuario",},
	},

  // {
  //   path: "/admin",
  //   name: "AdminDashboard",
  //   component: () => import("../views/admin/Index.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     role: "admin",
  //     title: "Escritorio Administrativo",
  //   },
  //   children: [
  //     {
  //       path: "negocios",
  //       name: "AdminBusiness",
  //       component: () => import("@/views/admin/Business.vue"),
  //       meta: { requiresAuth: true, role: "admin", title: "Negocios" },
  //     },
  //     {
  //       path: ":business_id/:business_name/categories",
  //       name: "AdminCategories",
  //       component: () => import("@/views/admin/Categories.vue"),
  //       meta: { requiresAuth: true, role: "admin", title: "Categorias" },
  //     },
  //     {
  //       path:
  //         ":business_id/:business_name/:category_id/:category_name/:category_subtitle?/items",
  //       name: "AdminItems",
  //       component: () => import("@/views/admin/Items.vue"),
  //       meta: { requiresAuth: true, role: "admin", title: "Items" },
  //     },
  //     {
  //       path: "clientes",
  //       name: "AdminCustomer",
  //       component: () => import("@/views/admin/Customer.vue"),
  //       meta: { requiresAuth: true, role: "admin", title: "Clientes" },
  //     },
  //   ],
  //},

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const lockedRoute = to.matched.some((record) => record.meta.requiresAuth);
  const user = firebase.auth().currentUser;
  if (lockedRoute === true && user === null) {
    next({ name: "Home" });
  } else {
    next();
  }
});

export default router
